import { Box, Checkbox, CircularProgress, FormControlLabel, Typography } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledCard } from '../../../../../../../components/StyledCard';
import { useFragment } from '../../../hooks/useFragment';
import { SubtitleDownloadBtns } from './SubtitleDownloadBtns';
import { useFragmentSubtitleDownloadUrls } from './useFragmentSubtitleDownloadUrls';

/**
 * Subtitle export card on the Files tab. Download actions are available only after transcription completes.
 */
export function FragmentSubtitlesFiles() {
  const { fragment } = useFragment();
  const [speakerIdCheck, setSpeakerIdCheck] = useState<boolean>(false);
  const isTranscriptionReady = fragment.transcriptionCompletedAt !== null;
  const downloadUrls = useFragmentSubtitleDownloadUrls(
    isTranscriptionReady ? fragment.id : undefined,
    speakerIdCheck,
  );

  return (
    <StyledCard
      size="sm"
      sx={{ maxWidth: 'md' }}
      title={<FormattedMessage id="fragments.subtitlesStatus.title" defaultMessage="Subtítulos" />}
    >
      {!isTranscriptionReady ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={16} />
          <Typography variant="body2" color="text.secondary">
            <FormattedMessage
              id="fragments.viewScreen.transcriptionNotReadyTooltip"
              defaultMessage="Esperando por transcripción de fragmento"
            />
          </Typography>
        </Box>
      ) : (
        <>
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  edge="start"
                  checked={speakerIdCheck}
                  onChange={(event) => {
                    setSpeakerIdCheck(event.target.checked);
                  }}
                />
              }
              label={
                <FormattedMessage
                  id="fragments.subtitlesStatus.add"
                  defaultMessage="Agregar ID de speaker"
                />
              }
            />
          </Box>
          <SubtitleDownloadBtns downloadUrls={downloadUrls} />
        </>
      )}
    </StyledCard>
  );
}
